import { ContentType } from '@candu-ai/content/types';

export const TOOLTIP_PLACEMENTS_CUSTOMIZATION = {
  [ContentType.HotspotGroup]: {
    title: 'Where will the Hotspot go?',
    urlLabel: 'Hotspot Group URL',
    selectorLabel: 'Hotspot HTML Selector',
  },
  [ContentType.Tour]: {
    title: 'Where will the Tour Step go?',
    urlLabel: 'Tour URL',
    selectorLabel: 'Tour Step HTML Selector',
  },
};
